/**
 * "Recent review" label in the shared MISMO review pop-up.
 * It shows for a review younger than 3 months, only when the theme setting "Reviews > Show a recent label" is on.
 * The tile block sets data-recent="1" on its root when the setting is on. The pop-up must sit inside that root.
 * The script watches each review pop-up. When the pop-up draws a review, it adds the label after the name line.
 * Review date: dialog.__st.cur.ts (milliseconds) or dialog.__st.cur.d (seconds).
 */
(function () {
  if (window.__mrRecent) return;
  window.__mrRecent = true;

  var LIMIT = 90 * 24 * 60 * 60 * 1000;

  function apply(dlg) {
    var st = dlg.__st;
    if (!st || !st.cur) return;
    var root = dlg.closest('[data-recent]');
    if (!root || root.getAttribute('data-recent') !== '1') return;
    var by = dlg.querySelector('.mismo-rv__by');
    if (!by || by.querySelector('.mismo-rv__new')) return;
    var r = st.cur;
    var t = r.ts || (r.d ? r.d * 1000 : 0);
    var age = Date.now() - t;
    if (!t || age < 0 || age > LIMIT) return;
    var s = document.createElement('span');
    s.className = 'mismo-rv__new';
    s.textContent = 'recent review';
    s.style.cssText = 'display:inline-block;margin-inline-start:8px;padding:1px 8px;border-radius:999px;background:#e9edd9;color:#0f2044;font-size:0.75rem;font-weight:600;';
    by.appendChild(s);
  }

  function watch(dlg) {
    if (dlg.__mrWatch) return;
    dlg.__mrWatch = true;
    new MutationObserver(function () { apply(dlg); }).observe(dlg, { childList: true });
  }

  function scan() {
    document.querySelectorAll('dialog.mismo-rv--review').forEach(watch);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
